import React from "react";
import { FrownIcon } from "lucide-react";
import { PROBLEMS } from "../lib/data";
export function ProblemSection() {
  return <section className="px-4 py-6" data-id="element-161" data-mp="2ltwb9qt06gw1">
      <h2 className="text-center text-2xl font-black leading-tight text-white" data-id="element-162" data-mp="2lqgw6nzbx7um">
        Preparar clases para una categoría puede ser bastante complejo 🥲
      </h2>

      <ul className="mt-5 space-y-3" data-id="element-163" data-mp="2vowo2t66kl56">
        {PROBLEMS.map(p => <li key={p} className="flex items-start gap-3 rounded-xl border border-white/10 bg-[#0f2c4a]/85 p-4 text-slate-100 backdrop-blur-sm" data-id="element-164" data-mp="39h4d1yr837tb">
            <FrownIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#e05a5a]" data-id="element-165" data-mp="3jgljwji7nrqv" />
            <span className="text-sm leading-snug" data-id="element-166" data-mp="3egz5w7uk67h0">{p}</span>
          </li>)}
      </ul>
    </section>;
}